var path = 'app/reporting/campaign_specific/hardlinkAnalytics.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;